export class AuthorizationForm {
  authorizationform_number = '';
  authorizationform_name = '';
  meter_number = '';
  primary_contact_name = '';
  primary_email = '';
  phone = '';
  rate_schedule = '';
  address_street = '';
  address_city = '';
  address_state = '';
  address_zip = '';
}
